import type { Backend } from '@freelancer/datastore/core';
import {
  OrderByDirection,
  getQueryParamValue,
} from '@freelancer/datastore/core';
import { toNumber } from '@freelancer/utils';
import type { ExternalReferenceCollection } from './external-reference.types';

export function externalReferenceBackend(): Backend<ExternalReferenceCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => {
      const givenContextIds = getQueryParamValue(query, 'contextId');
      const givenContextType = getQueryParamValue(query, 'contextType')[0];
      if (
        ids &&
        ids.length !== 0 &&
        givenContextIds &&
        givenContextIds.length !== 0 &&
        givenContextType
      ) {
        throw new Error(
          'contextId and contextType are not allowed when ids are provided',
        );
      }

      if (givenContextIds && givenContextType === undefined) {
        throw new Error('contextType is required when contextId is provided');
      }

      return {
        endpoint: 'external-reference/reference.php',
        isGaf: true,
        params: {
          ids,
          contextIds: givenContextIds,
          contextType: givenContextType,
        },
      };
    },
    push: (_, externalReference) => {
      if (externalReference.contextId === undefined) {
        throw new Error('contextId is required.');
      }
      if (externalReference.contextType === undefined) {
        throw new Error('contextType is required.');
      }
      if (externalReference.relationship === undefined) {
        throw new Error('relationship is required.');
      }

      if (externalReference.content === undefined) {
        throw new Error('content is required.');
      }

      return {
        endpoint: 'external-reference/reference.php',
        isGaf: true,
        payload: {
          contextId: externalReference.contextId,
          contextType: externalReference.contextType,
          relationship: externalReference.relationship,
          content: externalReference.content,
        },
      };
    },
    set: undefined,
    update: (authUid, delta, document) => {
      if (document.id === undefined) {
        throw new Error('id is required.');
      }
      if (delta.contextId === undefined) {
        throw new Error('contextId is required.');
      }
      if (delta.contextType === undefined) {
        throw new Error('contextType is required.');
      }
      if (delta.relationship === undefined) {
        throw new Error('relationship is required.');
      }
      if (delta.content === undefined) {
        throw new Error('content is required.');
      }

      return {
        endpoint: 'external-reference/reference.php',
        method: 'PUT',
        isGaf: true,
        payload: {
          id: document.id,
          contextId: delta.contextId,
          contextType: delta.contextType,
          relationship: delta.relationship,
          content: delta.content,
        },
      };
    },
    remove: (_, id, externalReferenceObject) => ({
      endpoint: 'external-reference/reference.php',
      method: 'DELETE',
      isGaf: true,
      payload: {
        id: toNumber(id),
      },
    }),
  };
}
